import { render } from "./debugzone.vue?vue&type=template&id=20936a42"
import script from "./debugzone.vue?vue&type=script&lang=js"
export * from "./debugzone.vue?vue&type=script&lang=js"
script.render = render

export default script